import { render, staticRenderFns } from "./TimeBenefitsHome.vue?vue&type=template&id=e6e84974"
import script from "./TimeBenefitsHome.vue?vue&type=script&setup=true&lang=js"
export * from "./TimeBenefitsHome.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports